import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    start: false,
    step: 0,
    costInputed: 0,
    gender: '',
    age: '',
    history: {},
    healthIssue: {},
    discuss: {},
    additionalInfo: '',
    cost: [0, 0, 0, 0, 0, 0, 0],
    completed: false
  },

  mutations: {
    setStep(state, step) {
      state.step = step;
      if (step >= 5) {
        state.completed = true;
      }
    },

    setGender(state, gender) {
      state.gender = gender;
    },

    setAge(state, age) {
      state.age = age;
    },

    setHistory(state, history) {
      state.history = history;
    },

    setHealthIssue(state, healthIssue) {
      state.healthIssue = healthIssue;
    },

    setDiscuss(state, discuss) {
      state.discuss = discuss;
    },

    setAdditionalInfo(state, additionalInfo) {
      state.additionalInfo = additionalInfo;
    },

    setStartStatus(state, status) {
      state.start = status;
    },

    setCostInputed(state, costInputed) {
      state.costInputed = costInputed;
    }
  },

  getters: {
    getCompletedStep: state => state.step,
    getGender: state => state.gender,
    getAge: state => state.age,
    getHistory: state => state.history,
    getHealthIssue: state => state.healthIssue,
    getDiscuss: state => state.discuss,
    getAdditionalInfo: state => state.additionalInfo,
    getCost: state => state.cost,
    getQuizCompleted: state => state.completed,
    getStartStatus: state => state.start,
    getCostInputed: state => state.costInputed
  }
});
